import { Component, OnInit } from "@angular/core";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-file-diagnostic",
  templateUrl: "./file-diagnostic.component.html",
  styleUrls: ["./file-diagnostic.component.css"],
})
export class FileDiagnosticComponent implements OnInit {
  loadingPage = false;
  bodyContent: String;
  sysLanguage: string = "ro";
  constructor(private apiBackend: ApiBackendService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.bodyContent = "In procesare";
    const id = this.route.snapshot.paramMap.get("id");
    this.apiBackend.getFileDiag(id, this.sysLanguage).subscribe((response: any) => {
      this.loadingPage = true;
      this.bodyContent = response.body.content;
      console.log(response);
    });
  }
}
